import * as React from 'react';
import Box from '@mui/material/Box';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';



interface DateRangePickerProps {
    startDate: Dayjs | null;
    endDate: Dayjs | null;
    onChange: (range: { startDate: Dayjs | null; endDate: Dayjs | null }) => void;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
    startDate,
    endDate,
    onChange,
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(newValue: Dayjs | null) => {
                        const newStart = newValue;
                        const shouldResetEnd = endDate && newStart && newStart.isAfter(endDate);
                        onChange({
                            startDate: newStart,
                            endDate: shouldResetEnd ? null : endDate,
                        });
                    }}
                    
                />
                <DatePicker
                    label="End Date"
                    value={endDate}
                    minDate={startDate ?? undefined}
                    onChange={(newValue: Dayjs | null) => {
                        onChange({ startDate, endDate: newValue });
                    }}

                />
            </Box>
        </LocalizationProvider>
    );
};

require('./styles.scss')